

export const personalInfo = {
  name: "Uday Kumar Siripireddy",
  title: "Frontend Developer",
  description: "I'm a Frontend Developer with 4 months of hands-on internship experience, focused on building responsive and dynamic web applications using HTML, CSS, JavaScript, and React.js. I’m passionate about clean code, intuitive user interfaces, and continuous learning. My journey into software development is fueled by curiosity, problem-solving, and a strong drive to grow into a full-stack engineer."
};

export const skills = [
  { name: "HTML", icon: "📄" },     
  { name: "CSS", icon: "🎨" },          
  { name: "JavaScript", icon: "📜" },   
  { name: "React.js", icon: "⚛️" },     
  { name: "Python", icon: "🐍" },       
  { name: "C/C++", icon: "🧩" },        
  { name: "Node.js", icon: "🌿" },      
  { name: "Express.js", icon: "🚂" },  
  { name: "MongoDB", icon: "🍃" },    
  { name: "FASTAPI", icon: "⚡" },     
  { name: "SQL", icon: "🗃️" },          
  { name: "AWS", icon: "☁️" },          
  { name: "Vercel", icon: "▲" },       
  { name: "Git/GitHub", icon: "🐙" },   
];


export const projects = [
   
  {
    title: "E-commerce Website",
    description: "An online store with user authentication and payment integration.",
    demoLink: "https://fetch-wishlist.vercel.app/",
    codeLink: "https://github.com/udaysiripireddy/fetch-wishlist",
  },
  {
    title: "Tech care",
    description: "A platform to manage patients records and data, with chart.js.",
    demoLink: "https://tech-care-iota.vercel.app/",
    codeLink: "https://github.com/udaysiripireddy/Tech-care",
  },{
    title: "Weather App",
    description: "A weather forecasting app using OpenWeather API.",
    demoLink: "https://monitoring-weather-app.vercel.app/",
    codeLink: "https://github.com/udaysiripireddy/Monitoring-weather-app",
  }




];

